import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function TermsOfUse() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-cream" data-id="element-958" data-mp="2srhidd8w3j5h">
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-id="element-959" data-mp="2xizgltjj35mr">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-960" data-mp="2xkiytpoqvqr6">
          <ArrowLeftIcon size={18} data-id="element-961" data-mp="2nsmw21bprcgm" />
          Back to Home
        </Link>

        <div name="termly-embed" data-id="90a7a752-e49d-4cbb-92cc-4f2a71686e42" data-type="iframe" data-mp="29tdi78azcuft"></div>
      </div>
    </div>;
}